import { render, staticRenderFns } from "./DoctorServices.vue?vue&type=template&id=23442332&scoped=true&lang=pug"
import script from "./DoctorServices.vue?vue&type=script&lang=js"
export * from "./DoctorServices.vue?vue&type=script&lang=js"
import style0 from "./DoctorServices.vue?vue&type=style&index=0&id=23442332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23442332",
  null
  
)

export default component.exports